import TableHeader from '@tiptap/extension-table-header';

export const TimeWebkitTableHeaderExtension = TableHeader;
